import { Controller } from "@hotwired/stimulus";

export const isChoicesBinded = (el) => !!el.dataset.choice

const CACHE_ID = '__choices_cache__'

// Connects to data-controller="choices"
export default class extends Controller {
  static values = {
    shoudldSort: { type: Boolean, default: false },
    html: { type: Boolean, default: false },
  };

  initialize() {
    if (this.isSelectOptionCached()) {
      this.recover()
    } else if (!this.isBinded()) {
      this.bind()
    }
  }

  connect() { }

  disconnect() { }

  recover() {
    const elemContainer = $(this.element).parents('.choices').get(0)

    if (elemContainer) {
      $(elemContainer).replaceWith($(this.$cachedSelectOption().text()))
      this.$cachedSelectOption().remove()
    }
  }

  bind() {
    const originSelectOptionHTML = this.element.outerHTML

    const extraOptions = {}
    if (this.htmlValue) {
      extraOptions.callbackOnCreateTemplates = (strToEl) => {
        const decodeHTML = (html) => {
          const textarea = document.createElement('textarea')
          textarea.innerHTML = html
          return textarea.value
        }
        return {
          item: function(classNames, data) {
            return strToEl(`
              <div
                class="${[
                  classNames.item,
                  classNames.itemSelectable,
                ].join(' ')}"
              >
                ${decodeHTML(data.label)}
              </div>
            `);
          },
          choice: function(classNames, data) {
            return strToEl(`
              <div
                class="${[
                  classNames.item,
                  classNames.itemChoice,
                  classNames.itemSelectable,
                ].join(' ')}"
                data-select-text="${this.config.itemSelectText}"
                data-choice ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : 'data-choice-selectable'
              } data-id="${data.id}" ${
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              }>
                ${decodeHTML(data.label)}
              </div>
            `);
          },
        }
      }
    }

    this.choices = new Choices(this.element, {
      classNames: { containerOuter: "choices is-invalid" },
      shouldSort: this.shoudldSortValue,
      callbackOnInit: () => {
        $(this.element).attr('data-pause', '')
      },
      ...extraOptions,
    })
    this.cacheSelectOptionHTML(originSelectOptionHTML)
  }

  isBinded() {
    return !!$(this.element).attr('data-binded')
  }

  $cachedSelectOption() {
    return $(this.element).prev(`#${CACHE_ID}`)
  }

  isSelectOptionCached() {
    return this.$cachedSelectOption().length > 0
  }

  cacheSelectOptionHTML(html) {
    $(`<div id="${CACHE_ID}"></div>`).hide().text(html).insertBefore(this.element)
  }
}
